"use strict";

exports.__esModule = true;

var _ocean = require("ocean");

var _ocean2 = _interopRequireDefault(_ocean);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_ocean2["default"].setQuery(_jquery2["default"]);

var location = window.location;
if (/\:/.test(location.host)) {
    _ocean2["default"].debugMode = true;
}
exports["default"] = {
    getApiDomain: function getApiDomain() {
        var hostName = _ocean2["default"].debugMode ? "gm99.com" : location.hostname.replace(/\w*\./, "");
        var childDomains = {
            "krevents.37.com": "//kreventsapi.",
            "other": "//eventsapi."
        };
        var eventDomain = window.location.hostname;
        var apiChildDomain = childDomains[eventDomain] || childDomains["other"];
        return apiChildDomain + hostName;
    },

    getLocationParam: function getLocationParam(paramName, newhref) {
        var href = newhref;
        if (window.location.search) {
            href = href || window.location.search.split("?")[1];
        } else {
            href = href || window.location.href.split("?")[1];
        }
        var reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)");
        var matchResult = "";
        if (href) {
            matchResult = href.match(reg);
        }

        var param = matchResult ? decodeURI(matchResult[2]) : "";

        return param;
    },

    getActivityId: function getActivityId() {
        var aictivityId = "";
        var href = window.location.pathname;
        if (/events\.37\.com/.test(window.location.origin)) {
            href = href.replace(/(\/en\/)|(\/fr\/)|(\/tr\/)|(\/pt\/)|(\/de\/)/, "/");
        }
        try {
            aictivityId = href.match(/\w*\/(?:(m\/(?:\?|([\w|\-|_]*\.html)|$))|\?|([\w\-|_]*\.html)|$)/)[0].split("/")[0];
        } catch (e) {
            aictivityId = this.getLocationParam(href);
        }
        return aictivityId;
    },
    stat: function stat() {
        var url = [this.getApiDomain() + '/static_activity/visit_log', '?name=' + this.getActivityId(), '&source_url=' + window.location.href, '&referer_url=' + document.referrer, '&cid=' + _ocean2["default"].location.getParam('cid'), '&scid=' + _ocean2["default"].location.getParam('scid')].join('');
        _ocean2["default"].ajax.jsonp(url, {}, function () {});
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/activity_config.js
// module id = 107
// module chunks = 7 8